import React from "react";
import Layout from '../components/layout'
import SEO from '../components/seo'
import Navigation from '../components/navigation.js'
import PostDescription from '../components/post-description';
import { graphql } from 'gatsby';
import { css } from "@emotion/core"
import ImagePodcast from '../components/ImagePodcast'

const Category = ({ data, pageContext }) => {

    const sImg = css`
        margin-right: 10px;
    `

    const sImgCategory = css`
        text-align: center;
    `;
    const post = data.category;
    
    return (
        <Layout>
            <SEO title={post.frontmatter.title} description={post.excerpt} keywords={['category', post.frontmatter.title]} />
            <h1>
                {post.frontmatter.podcast && (
                        <span css={sImg}><ImagePodcast /></span>
                    )
                }
                {post.frontmatter.title}
            </h1>

            <div dangerouslySetInnerHTML={{ __html: post.html }} />

            <div css={sImgCategory}>
                <img src={post.frontmatter.image.childImageSharp.fixed.src} alt={post.frontmatter.title} />
            </div>

            {data.allCategories.edges.map(({ node }) => 
                <div key={node.id}>
                    <PostDescription
                        titlepost={node.frontmatter.title}
                        excerpt={node.excerpt}
                        slug={node.fields.slug}
                        timeToRead={node.timeToRead}
                        tags={node.frontmatter.tags}
                        topico={node.frontmatter.category}
                        langKey={node.frontmatter.langKey}
                        imgSrc={node.frontmatter.image}
                    />
                    <hr />
                </div>
            )}

            <Navigation 
                pageContext={pageContext}
                totalCount={data.allCategories.totalCount}
            />
        </Layout>
    );
};

export const query = graphql`
    query PostCategoryQuery($sCategory: String!, $sLangKey: String!, $skip: Int, $limit: Int) {
        category: markdownRemark(
            frontmatter: { 
                title: { 
                    eq: $sCategory 
                }
                langKey: {
                    eq: $sLangKey
                }
            }
        ) {
            html
            excerpt
            frontmatter {
                title
                image {                      
                    childImageSharp {
                        fixed(width: 400, height:400) {
                            src
                        }
                    }
                }
                podcast
            }
            fields {
                slug
            }
        }
        allCategories: allMarkdownRemark(
            skip: $skip
            limit: $limit
            filter: { 
                frontmatter: { 
                    category: { 
                        eq: $sCategory
                    }
                    langKey: {
                        eq: $sLangKey
                    }
                } 
            }
            sort: {
                fields: [frontmatter___date], order: DESC
            }
        ) {
            totalCount
            edges {
                node {
                    id
                    frontmatter {
                        title
                        tags
                        category
                        langKey
                        image {
                            publicURL
                        }
                    }
                    fields {
                        slug
                    }
                    excerpt
                    timeToRead
                }
            }
        }
    }
`;

export default Category